import "./App.css";
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import useTheme from "./components/useTheme";
import { AnimatePresence } from "framer-motion";
import Login from "./pages/LoginPage";
import Home from "./pages/HomePage";
import Register from "./pages/RegisterPage";
import Page404 from "./pages/Page404";
import Password from "./pages/PasswordsPage";
import Files from "./pages/FilesPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import GeneratePasswordPage from "./pages/GeneratePasswordPage";
import AuthRoute from "./components/AuthRoute";
import "react-toastify/dist/ReactToastify.css";
import { Slide } from "react-toastify";
import { UserAuthContextProvider } from "./auth";
import { ToastContainer } from "react-toastify";

function App() {
	let [theme, icon] = useTheme();
	const location = useLocation();
	return (
		<div className={[theme, "wrapper"].join(" ")}>
			<span className="themeicon">{icon}</span>
			<div className="title">
				<p>Securespace</p>
				<span>A secure space for Notes, Passwords and Files.</span>
			</div>
			<ToastContainer theme={theme} draggablePercent={40} transition={Slide} />
			<UserAuthContextProvider>
				<AnimatePresence exitBeforeEnter initial={false}>
					<Routes location={location} key={location.pathname}>
						<Route
							exact
							path="/"
							element={
								<AuthRoute>
									<Home />
								</AuthRoute>
							}
						/>
						<Route exact path="/login" element={<Login />} />
						<Route exact path="/register" element={<Register />} />
						<Route exact path="/passwords" element={<Password />} />
						<Route exact path="/files" element={<Files />} />
						<Route exact path="/forgotpassword" element={<ForgotPasswordPage />} />
						<Route exact path="/resetpassword" element={<ResetPasswordPage />} />
						<Route exact path="/password" element={<GeneratePasswordPage />} />
						<Route path="*" element={<Page404 />} />
					</Routes>
				</AnimatePresence>
			</UserAuthContextProvider>
			<div className="footer">
				<p>
					&copy; <strong>2022</strong> | Created by{" "}
					<span onClick={() => window.open("https://bhargava73.github.io")} style={{ color: "#1da1f2", fontWeight: "bold", textDecoration: "none", marginRight: "8px", cursor: "pointer" }}>
						Bhargava A
					</span>
					using React and Firebase.
				</p>
			</div>
		</div>
	);
}

export default App;
